<template lang="pug">
AppSelect(
  :value="selectedTime"
  :options="availableTimes"
  @input="selectedTime = $event"
)
</template>

<script>
export default {
  name: 'AppTimeSelect',
  props: {
    minuteInterval: {
      type: Number,
      default: 60,
    },
    value: {
      type: [Object, Date, String],
      default: () => {},
    },
  },
  emits: ['input'],
  data: () => ({
    defaultTime: '2000-01-01T00:00:00Z',
  }),
  computed: {
    selectedTime: {
      get() {
        if (this.value) {
          // Normalize the given value
          const momentValue = moment(this.value).utc();
          const convertedMomentValue = moment.utc(this.defaultTime);

          convertedMomentValue.utc().minutes(momentValue.minutes());
          convertedMomentValue.utc().hours(momentValue.hours());

          return convertedMomentValue.utc().format();
        }

        return '';
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    availableTimes() {
      let acc = 0;
      const minuteOptions = [];
      const hourMinuteOptions = [];

      while (acc < 60) {
        minuteOptions.push(acc);
        acc = acc + this.minuteInterval;
      }

      for (let h = 0; h < 24; h++) {
        const currentOptionDateTime = moment.utc(this.defaultTime);

        currentOptionDateTime.utc().hour(h);

        minuteOptions.forEach((minute) => {
          currentOptionDateTime.utc().minute(minute);
          hourMinuteOptions.push({
            id: currentOptionDateTime.utc().format(),
            text: TimeUtils.format_time(currentOptionDateTime.utc()),
          });
        });
      }

      return hourMinuteOptions;
    },
  },
};
</script>
